export const formatPrice = (price: number) => {
  const formatter = new Intl.NumberFormat('ko-KR');
  return formatter.format(price);
};
